import axios from 'axios';

class AutoCadastroService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || 'https://portalrelacionamentoapi.dev-gam.com';
    }

    async verificarCliente(codigoCliente, cnpjCpf) {
        const response = await axios.post(`${this.apiUrl}/auto-cadastro/verificar-cliente`, {
            codigoCliente,
            cnpjCpf,
        });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível verificar o cliente.');
        }

        return response.data.conteudo;
    }

    async cadastrarMaster({ codigoCliente, cnpjCpf, nmUsuario, dsEmail }) {
        const response = await axios.post(`${this.apiUrl}/auto-cadastro/cadastrar-master`, {
            codigoCliente,
            cnpjCpf,
            nmUsuario,
            dsEmail,
        });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Erro ao cadastrar usuário master.');
        }

        return response.data.mensagem;
    }

    async ativarConta(token, novaSenha) {
        const response = await axios.post(`${this.apiUrl}/auto-cadastro/ativar-conta`, { token, novaSenha });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível ativar a conta.');
        }
    }

    async esqueciSenha(login) {
        const response = await axios.post(`${this.apiUrl}/auto-cadastro/esqueci-senha`, { login });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível processar a solicitação.');
        }

        return response.data.mensagem;
    }

    async redefinirSenha(token, novaSenha) {
        const response = await axios.post(`${this.apiUrl}/auto-cadastro/redefinir-senha`, { token, novaSenha });

        if (response.data.status !== 'OK') {
            throw new Error(response.data.mensagem || 'Não foi possível redefinir a senha.');
        }
    }
}

export default new AutoCadastroService();
